// See https://stackoverflow.com/a/64174790

export const colors = [
	'none',
	'red',
	'orange',
	'yellow',
	'green',
	'blue',
	'purple'
];

export type Color = typeof colors[number];
